<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <header class="header">
        <a [routerLink]="['/']">
          <img class="header-logo" src="assets/images/logo/logo.svg" alt="" />
        </a>
      </header>
      <div class="text-center mt-5">
        <p>{{ 'errors.event_not_found'| translate }} </p>
      </div>
    </div>
  </div>
  <footer class="footer footer-fix">
    <app-footer></app-footer>
  </footer>
</div>